import sanityClient from "@sanity/client";

export default sanityClient({
  projectId: "6nljrt1e", 
  dataset: "production", 
  useCdn: true,
});
